import { Button, Modal } from 'react-bootstrap'

interface IProps {
    isOpen: boolean
    onClose: () => void
    onApplyForPage: () => void
    onApplyForFilter?: () => void
    disableFilterButton?: boolean
}

export const ModalPartsBulkApply = ({
    isOpen,
    onClose,
    onApplyForPage,
    onApplyForFilter,
    disableFilterButton = false,
}: IProps) => (
    <Modal
        show={isOpen}
        onHide={onClose}
        centered
        dialogClassName="modal-md"
    >
        <Modal.Header closeButton>
            <Modal.Title as="h6" className="fs-6">
                Применить действие для всех запчастей по активному фильтру или только для текущей страницы?
            </Modal.Title>
        </Modal.Header>
        <Modal.Footer className="d-flex flex-nowrap justify-content-between gap-2">
            <Button
                variant="primary"
                onClick={onApplyForPage}
                className="flex-fill fs-6 py-2"
            >
                Для текущей страницы
            </Button>
            <Button
                variant="secondary"
                onClick={onApplyForFilter}
                disabled={disableFilterButton}
                className="flex-fill fs-6 py-2"
            >
                Для активного фильтра
            </Button>
        </Modal.Footer>
    </Modal>
)
